// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ozAc","left":"styles_left__1ZuZJ","desktopActions":"styles_desktopActions__1-las","title":"styles_title__DsCmK"};